import { bloquesJornada, diaCorto, horaLocal } from '@/shared/utilidades/jornada'

import estilos from './HorarioObra.module.css'

/**
 * El horario de una obra, partido en bloques con el almuerzo a la vista.
 *
 * Muestra «Mañana 7:00 a. m. – 12:00 m. · Almuerzo 12:00 – 1:00 p. m. · Tarde
 * 1:00 – 4:00 p. m.», y si la obra cruza a otro día, lo separa por fecha. Así
 * una obra de 8 horas no se lee como un bloque corrido, y queda claro que a
 * mediodía se para.
 */
export function HorarioObra({
  inicio,
  horas,
}: {
  inicio: string | null | undefined
  horas: number | null | undefined
}) {
  const segmentos = bloquesJornada(inicio, horas)
  if (segmentos.length === 0) return null

  // ¿La obra cruza a más de un día? Entonces se rotula cada día.
  const dias = new Set(segmentos.map((s) => s.inicio.toDateString()))
  const variosDias = dias.size > 1

  let diaActual = ''

  return (
    <div className={estilos.zona}>
      {segmentos.map((s, i) => {
        const claveDia = s.inicio.toDateString()
        const nuevoDia = variosDias && claveDia !== diaActual
        diaActual = claveDia

        return (
          <div key={i} className={estilos.fila}>
            {nuevoDia && <span className={estilos.dia}>{diaCorto(s.inicio)}</span>}
            <span className={`${estilos.tramo} ${s.tipo === 'almuerzo' ? estilos.almuerzo : ''}`}>
              <span className={estilos.rotulo}>{s.tipo === 'almuerzo' ? 'Almuerzo' : 'Trabajo'}</span>
              <span className={estilos.horas}>
                {horaLocal(s.inicio)} – {horaLocal(s.fin)}
              </span>
            </span>
          </div>
        )
      })}
    </div>
  )
}
